import { createSlice } from '@reduxjs/toolkit'
import { ClubSanctionList } from './thunk'

export const initialState = {
    ClubSanctionList: [],
    activeClub: '',
    loading: true
}
const ClubSanction = createSlice({
    name: '@ClubSanction',
    initialState,
    reducers: {
        changeActiveClubSanction: (state, action) => {
            state.activeClub =
                state.activeClub === action.payload.activeClub ? '' : action.payload.activeClub
        }
    },
    extraReducers: (builder) => {
        // Listing
        builder.addCase(ClubSanctionList.pending, (state) => {
            state.activeClub = ''
            state.loading = true
        })
        builder.addCase(ClubSanctionList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.ClubSanctionList = data
            state.loading = false
        })
        builder.addCase(ClubSanctionList.rejected, (state) => {
            state.loading = false
        })
    }
})

export const { changeActiveClubSanction } = ClubSanction.actions
export default ClubSanction.reducer
